import { Component, OnInit } from '@angular/core';
import { ActivatedRoute, Router } from '@angular/router';
import saveAs from 'file-saver';
import { MenuItem, MessageService } from 'primeng/api';
import { first } from 'rxjs';
import { ActivityRecordService } from 'src/app/services/activity-record.service';
import { AppLoaderService } from 'src/app/services/app-loader/app-loader.service';
import { CryptoJsService } from 'src/app/services/crypto-js.service';
import { DepartmentDashboardService } from 'src/app/services/department-dashboard.service';

@Component({
  selector: 'app-benificiary',
  templateUrl: './benificiary.component.html',
  styleUrls: ['./benificiary.component.scss']
})
export class BenificiaryComponent implements OnInit {

  public tableData = [];
  public cols: any = [];
  isSubmitted = false;
  applicationId: any = null;
  inputId: any = '';
  inputPhone: any = '';
  userID: any;
  // table: boolean = false;
  public tableHeaderName = 'Benificiary Details';
  BenificiaryReport: MenuItem[];

  constructor(
    public router: Router,
    private messageService: MessageService,
    private route: ActivatedRoute,
    private activityRecordService: ActivityRecordService,
    private deptDashBoardService: DepartmentDashboardService,
    private loader: AppLoaderService,
    private cryptoJsService: CryptoJsService
  ) { }

  ngOnDestroy(): void {
  }

  ngOnInit(): void {
    let sessionToken = this.cryptoJsService.DecryptToken(sessionStorage.getItem('token'));
    let payload = atob(JSON.parse(sessionToken).authToken?.split('.')[1]);
    this.userID = JSON.parse(payload)?.sub;
    this.activityRecordService.activityRecord(this.userID, 'Application Status', '', new Date(), 'Success');

    this.BenificiaryReport = [
      {
        label: 'Download excel',
        icon: 'pi pi-fw pi-download',
        command: () => {
          this.exportExcel(this.tableData, `MI_${this.tableHeaderName}`);
        },
      }
      ,
    ];
  }

  getApplicationStatus() {
    if (!this.inputId && !this.inputPhone) {
      this.messageService.add({
        severity: 'error',
        summary: 'Error Message',
        detail: 'Enter Application Id/ Aadhar No Or Phone No',
      });
      return;
    }

    if (this.inputId) {
      if (this.inputId.length == 12) {
        this.inputPhone = '';
        this.getApplicationNo(this.inputId, this.inputPhone);
      } else if (this.inputId.startsWith('MI')) {
        this.applicationId = this.inputId;
        this.checkApplicationDetails();
      } else {
        this.messageService.add({
          severity: 'error',
          summary: 'Error Message',
          detail: 'Enter Application Id/ Aadhar No properly.',
        });
      }
    }

    if (this.inputPhone) {
      if (this.inputPhone.length === 10) {
        this.inputId = '';
        this.getApplicationNo(this.inputId, this.inputPhone);
      } else {
        this.messageService.add({
          severity: 'error',
          summary: 'Error Message',
          detail: 'Enter Phone No properly.',
        });
        return;
      }
    }

    // this.table = true;
    this.isSubmitted = true;
  }

  getApplicationNo(Aadhaar, mobile) {
    this.loader.start();
    this.deptDashBoardService
      .getAppIdByAadharNoOrPhone(Aadhaar, mobile)
      .pipe(first())
      .subscribe({
        next: (data) => {
          this.loader.close();
          data = data.Table;
          if (data[0].Message) {
            this.tableData = [];
            this.cols = [];

            this.messageService.add({
              severity: 'info',
              summary: 'Info Message',
              detail: data[0].Message,
            });
            return;
          } else {
            this.tableData = data;
            this.cols = Object.keys(data[0]);
          }
          this.activityRecordService.activityRecord(this.userID, 'Get Application by Aadhar No', Aadhaar, new Date(), 'Success');
        },
        error: (err) => {
          this.tableData = [];
          this.cols = [];
          this.loader.close();
          this.activityRecordService.activityRecord(this.userID, 'Get Application by Aadhar No Err', Aadhaar, new Date(), err);

          this.messageService.add({
            severity: 'error',
            summary: 'Error Message',
            detail: err,
          });
        },
      });
  }

  checkApplicationDetails() {
    this.ngOnDestroy();
    if (((this.router.url.startsWith('/helpdesk')))) {
      this.router.navigate(['helpdesk', 'home', 'view'], { queryParams: { appId:this.cryptoJsService.Encrypt(this.applicationId.toString()) } });
      // this.router.navigate(['helpdesk', 'home', this.applicationId]);
    } else {
      this.router.navigate(['department', 'helpdesk', 'view'], { queryParams: { appId:this.cryptoJsService.Encrypt(this.applicationId.toString()) } });
      // this.router.navigate(['department', 'helpdesk', this.applicationId]);
    }
  }

  clearData() {
    this.tableData = [];
    this.inputPhone = null;
    this.inputId = null;
  }


  exportExcel(modelData, filename) {
    if (!modelData) {
      modelData = [];
    }
    import('xlsx').then((xlsx) => {
      let dataToSave = modelData;
      // let dataToSave = modelData.map((d: any) => {
      //   return {
      //     'Aadhar': d.Aadhar,
      //     'Application ID': d.Application_ID,
      //     'Area': d.Area,
      //     'Category': d.Category,
      //     'Department': d.Department,
      //     'District': d.District,
      //     'FarmerName': d.FarmerName,
      //     'FatherName': d.FatherName,
      //     'JE Verification Amount': d.JEVerificationAmount,
      //     'Land Details': d.LandDetails,
      //     'Mobile': d.Mobile,
      //     'Registration Date': d.Registration_Date,
      //     'Total Cost Verification': d.TotalCostVerification,
      //     'Vendor Name': d.Vendor_Name,
      //     'Village': d.Village,
      //     'Year': d.Year,
      //     'System': d.System
      //   };
      // });
      const worksheet = xlsx.utils.json_to_sheet(dataToSave);
      const workbook = { Sheets: { data: worksheet }, SheetNames: ['data'] };
      const excelBuffer: any = xlsx.write(workbook, {
        bookType: 'xlsx',
        type: 'array',
      });
      this.saveAsExcelFile(excelBuffer, filename);
    });
  }
  saveAsExcelFile(buffer: any, fileName: string): void {
    import('file-saver').then((FileSaver) => {
      let EXCEL_TYPE =
        'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet;charset=UTF-8';
      let EXCEL_EXTENSION = '.xlsx';
      const data: Blob = new Blob([buffer], {
        type: EXCEL_TYPE,
      });
      saveAs(
        data,
        fileName + '_export_' + new Date().getTime() + EXCEL_EXTENSION
      );
    });
  }

}
function convertToArray(tableData: any): any {
  throw new Error('Function not implemented.');
}

